<template>
  <div class="w-full text-center empty-state">

      <img
        class="empty-img"
        src="@/assets/images/test-connection-empty.svg"
        alt="test connection empty"
      />

      <div class="start-hint">{{$t('Enter your website URL to start testing connection.')}}</div>

      <div  class="flex text-left justify-center">
        <TestConnectionActions :btnTestText="$t('tracking.test_connection_tab.btn_test')" @update-done="updateValues"/>
      </div>
  </div>
</template>

<script>
import TestConnectionActions from './TestConnectionActions.vue'

export default {
  methods:{
    updateValues (newValues) {
      this.$emit('update-done', newValues)
    }
  },
  components:{
    TestConnectionActions
  }
}
</script>

<style lang="scss" scoped>

$hintColor: #323232;

.empty-state {
  margin-top: 40px;
}

.empty-img {
  width: 173px;
  height: 130px;
  margin-bottom: 18px;
}

.start-hint {
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.107143px;
  color: $hintColor;
  margin-bottom: 20px;
}

</style>

